import React from 'react'
import styles from './ZoomFloatingActions.module.scss'
import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons'
import TooltipSquareRadioButton from '@app/pages/reviewer/components/TooltipSquareRadioButton'

export function ZoomFloatingActions({ zoomIn, zoomOut, scale, recalculateScale }) {
  return (
    <div className={styles.ZoomFloatingIndicator} data-test-id="zoom-floating-actions-container" id="reviewer-floating-actions">
      <TooltipSquareRadioButton
        data-test-id="floating-actions-zoom-in-button"
        icon={<ZoomInOutlined />}
        title="Zoom in"
        onClick={zoomIn}
        disabled={!zoomIn}
      />
      <TooltipSquareRadioButton
        data-test-id="floating-actions-zoom-out-button"
        icon={<ZoomOutOutlined />}
        title="Zoom out"
        onClick={zoomOut}
        disabled={!zoomOut}
      />
      <div className={styles.zoomFitWidth}>
        <TooltipSquareRadioButton
          data-test-id="floating-actions-page-width-button"
          icon={<span style={{ userSelect: 'none' }}>Fit Width</span>}
          onClick={recalculateScale}
          disabled={!recalculateScale}
        />
      </div>
      {scale && (
        <div className={styles.zoomIndicator} data-test-id="zoom-floating-actions-zoom-indicator">
          {Math.round(scale * 100)}%
        </div>
      )}
    </div>
  )
}
